import { useRouter } from 'next/router';
import { useGlobalConfig } from '../../hooks/configContext';
import { getURLConfigForPath } from './localizedSanityPaths';
import { Otovo$Locale } from '../../types/otovoweb';

export default function useLocalizedPath(path: string): string {
  const config = useGlobalConfig();
  const { locale } = useRouter() as { locale: Otovo$Locale };

  return getURLConfigForPath(path, config.BU_CONFIG.market, locale)
    .localizedPath;
}
